import React, {useState} from "react";
import tw from "twin.macro";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import Hero from "./Hero.js";
import MainFeature from "components/features/TwoColWithButton.js";
import GetStarted from "./GetStarted";
import mriApproach from "images/mri-approach.jpg";
import mriBenefits from "images/mri-benefits.jpg";
import Footer from "../../components/footers/FiveColumnWithInputForm";
import TwoColGrid from "./TwoColGrid";
import styled from "styled-components";
import {Modal} from "react-responsive-modal";
import ContactUsForm from "../../components/forms/TwoColContactUsWithIllustrationFullForm";


const ListItem = styled.li`
    ${tw`flex items-baseline text-secondary-100 mb-2`}
    img {
        ${tw`mr-2`}
    }`;

const HighlightedText = tw.span`text-primary-500`;


export default () => {
    const [openModal, setOpenModal] = useState(false);

    return (
        <AnimationRevealPage>
            <Hero roundedHeaderButton={true} onClick={() => setOpenModal(true)}/>
            <TwoColGrid
                heading="Introducing MRI-MAI — the world’s first platform to synchronise 3D movement with MRI biomarkers."
                cards={["https://www.youtube.com/watch?v=tmH4hC1XJ_k","https://youtube.com/shorts/KZnOncNJSe4?feature=shared", "https://youtube.com/shorts/gbiG8ctz_6g?feature=shared", "https://youtube.com/shorts/38Ka-OFKa6Y?feature=shared"]}
                description="Every joint tells a story — not just in structure, but in movement. MAI Motion captures 3D motion with a single smartphone camera, while MRI reveals deep tissue structures. Together, they enable a new kind of diagnosis: functional, predictive, and personalised."
            />
            <div style={{ padding: "40px 0px" }}>
            <MainFeature
                subheading=""
                imageSrc={mriApproach}
                imageBorder={true}
                imageDecoratorBlob={true}
                imgWidth="80%"
                heading={
                <>
                    <HighlightedText>Our</HighlightedText> Unique Approach
                </>
                }
                description={
                    <div style={{marginTop: 15}}>
                        <p style={{ fontSize: 24, fontFamily: "Poppins Medium" }}>
                        Built for real clinics, not research labs
                        </p>
                        <br />
                        <ul>
                            <ListItem>
                                <img src={require("images/new-ui-imgs/check.png")}/>
                                Markerless 3D motion capture
                            </ListItem>
                            <ListItem>
                                <img src={require("images/new-ui-imgs/check.png")}/>
                                AI-powered segmentation of MRI structures
                            </ListItem>
                            <ListItem>
                                <img src={require("images/new-ui-imgs/check.png")}/>
                                MRI biomarkers extracted per scan
                            </ListItem>
                            <ListItem>
                                <img src={require("images/new-ui-imgs/check.png")}/>
                                Linking anatomy to movement
                            </ListItem>
                            <ListItem>
                                <img src={require("images/new-ui-imgs/check.png")}/>
                                Runs on standard phones and laptops
                            </ListItem>
                        </ul>

                    </div>
                }
                hideButton
                textOnLeft
                alignCenter
                centerImgWithYellow
            />
            </div>
            <div style={{ padding: "40px 0px" }}>
            <MainFeature
                // subheading={<Subheading>Benefits</Subheading>}
                imageSrc={mriBenefits}
                imageBorder={true}
                imageDecoratorBlob={true}
                imgWidth="100%"
                heading={<>
                    The Benefits of
                    <HighlightedText> MRI-MAI </HighlightedText>
                </>}
                description="MRI-MAI isn’t just another AI tool — it’s a clinical-grade breakthrough that combines how joints look on MRI with how they function in motion. "
                subdescription={<div>
                    <ul>
                        <ListItem>
                            <img src={require("images/new-ui-imgs/check.png")}/>
                            Faster decisions.
                        </ListItem>
                        <ListItem>
                            <img src={require("images/new-ui-imgs/check.png")}/>
                            Fewer missed diagnoses.
                        </ListItem>
                        <ListItem>
                            <img src={require("images/new-ui-imgs/check.png")}/>
                            Better outcomes.
                        </ListItem>
                    </ul></div>}
                hideButton
                textOnLeft={false}
                alignCenter
                centerImgWithYellow
            />
            </div>
            <div style={{ padding: "40px 0px" }}>
            <GetStarted onClick={() => setOpenModal(true)}/>
            </div>
            <Footer/>
            {openModal &&  <Modal
                open
                onClose={() => setOpenModal(false)}
                center
                styles={{
                    modal: { padding: 40 },
                }}
            >
                    <ContactUsForm isMRI />
            </Modal>}
        </AnimationRevealPage>
    );
}
